import styled from '@emotion/styled/macro';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { CardContent, FlexWrapper } from '../../../../theme/common_style';
import Title from 'antd/es/typography/Title';
import CountUp from 'react-countup';
import { useTheme } from '@emotion/react';
import { useWindowWide } from '../../../../utils/common_functions';

const HmsCard = ({ image, bg, loading, filterKey, onClick, title, value, active }) => {
  const largeScreen = useWindowWide;
  const theme = useTheme();
  return (
    <Card
      prefixCls="hms-card"
      loading={loading}
      style={{ textAlign: 'left', width: '100%', height: '100%' }}>
      <FlexWrapper
        direction="column"
        justify="start"
        align="start"
        gap="10px"
        width={largeScreen ? '100%' : 'fit-content'}>
        <ImageWrapper bg={bg} onClick={() => filterKey && onClick(filterKey)}>
          {image}
        </ImageWrapper>
        <Box>
          <CardContent>{title}</CardContent>
          <Title style={{ margin: 0 }} level={2}>
            <CountUp
              className="counter-style"
              style={{ color: active?.includes(filterKey) ? theme.primaryColor : '#000' }}
              end={value.toString().padStart(2, '0')}
            />
          </Title>
        </Box>
      </FlexWrapper>
    </Card>
  );
};

export default HmsCard;

HmsCard.propTypes = {
  image: PropTypes.element,
  bg: PropTypes.string,
  loading: PropTypes.bool,
  filterKey: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.any,
  active: PropTypes.arrayOf(PropTypes.string)
};

const ImageWrapper = styled.div`
  background-color: ${({ bg }) => bg};
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  @media (max-width: 600px) {
    display: none;
  }
`;
const Box = styled.div`
  @media (max-width: 600px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 0px;
    .counter-style {
      font-size: 20px;
      margin: 0;
      padding: 0;
    }
  }
`;
